module.exports = __webpack_public_path__ + "img/2.60cd9f50.jpg";